const selectIsDraftExpandView = state => state.draftToolbar.isExpandView;

export default {
  selectIsDraftExpandView,
};
